var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"roll_text_box"},[_c('transition',{attrs:{"name":"slide"}},[_c('p',{key:_vm.text.id,staticClass:"roll_text"},[_c('span',{on:{"click":function($event){return _vm.clickMethod(_vm.text.val.id)}}},[_vm._v("\n          "+_vm._s(_vm.text.val.title)+"\n        ")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487deded","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/rollNotice/rollNotice.vue
// module id = null
// module chunks = 